// Daily AI quota (backend services/ai_quota_service.py, Faz 10)
import { createAuthenticatedApi } from './apiInterceptors';

const api = createAuthenticatedApi();

export type AiQuotaPool = 'plan' | 'plan_change' | 'questions' | 'task_assist';

export interface AiQuotaPoolStatus {
  used: number;
  limit: number;
  remaining: number;
}

export interface AiQuota {
  plan: string;
  pools: Record<AiQuotaPool, AiQuotaPoolStatus>;
  /** ISO time of the next reset (midnight Istanbul time) */
  resets_at: string;
}

export const AI_QUOTA_POOLS: AiQuotaPool[] = ['plan', 'plan_change', 'questions', 'task_assist'];

export const getAiQuota = async (): Promise<AiQuota> => {
  const response = await api.get('/ai/quota');
  return response.data;
};
